<template>
<!--  eslint-disable -->
  <div style="align-items: center;display: flex;">
    <el-icon class="el-icon-s-home"></el-icon>
    &nbsp;&nbsp;&nbsp;
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :key="item.name" v-for="(item) in breadcrumblist">
            <span>{{item.name}}</span>
        </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
    

</template>

<script>
// import router from '@/router';
// import { useRoute } from 'vue-router';
import store from '@/store'
export default{
        name: "BreadCrumbView",
        data(){
            return {
                breadcrumblist : [],
                route : null
            }
        },

        watch:{
            // $route((to, from)=>{
            //     this.initBreadcrumb()
            // })
            $route(to){
                this.initBreadcrumb()
                if (to.name == '个人中心') {
                    // if (this.$router.currentRoute.name != '个人中心'){
                        
                    // }

                    store.commit('ADD_TABS',{
                        name: '个人中心',
                        path:'/userCenter'
                    })
                }
            }
        },
        
        mounted(){
            this.initBreadcrumb()
        },
        methods:{
            initBreadcrumb(){
                this.breadcrumblist = this.$route.matched
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>